export const getMatas = matas => ({
    type: 'GET_MATAS',
    matas: matas
});

export const delMata = hash => ({
   type: 'DEL_MATA',
   hash: hash
});

const initialState = [];

export default (state = initialState, action = {}) => {
    if (action.type === 'GET_MATAS') {
        state = action.matas;
    }
    else if (action.type === 'DEL_MATA') {
        state = state.filter(mata => mata.hash !== action.hash)
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/getMatas.js